// extracted by mini-css-extract-plugin
export default {"background":"Modal_background__zodZP","modal":"Modal_modal__57jNV","foto":"Modal_foto__ndyy3","info":"Modal_info__ArY6M","icon":"Modal_icon__dhHI5"};